import React from 'react';
import _ from 'lodash';

import styles from './AdminSelect.module.css';

const AdminSelect = ({
  name,
  label,
  list,
  selected,
  selectLabel,
  handleChange,
  style,
  disabled,
  error,
  propRef,
  dataRecurly,
}) => {
  return (
    <div className={styles.container} style={style}>
      {label && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <select
        className={`${styles.select} ${error ? styles.error : ''}`}
        name={name}
        value={selected}
        onChange={handleChange}
        disabled={disabled}
        ref={propRef}
        data-recurly={dataRecurly}
      >
        {selectLabel && <option value="">{selectLabel}</option>}
        {_.map(list, (item) => (
          <option key={item.id || item.value} value={item.id || item.value}>
            {item.name ? item.name : item.displayName}
          </option>
        ))}
      </select>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
};

export default AdminSelect;
